export default __webpack_public_path__ + "static/media/backhandSmash.38d3af4e.webp";